import { testimonials } from '@/mocks/homeData';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-16 md:py-24 px-4 md:px-6 bg-secondary-50">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
            <span className="text-sm text-secondary-700 font-medium">书友雅评</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            书友雅评
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            听听漫友们怎么说，真实口碑值得信赖
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <article
              key={t.id}
              className={`p-6 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-accent-200 ${
                idx === testimonials.length - 1 ? 'lg:opacity-70' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-sm ${
                      i < t.rating ? 'text-amber-400' : 'text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-3">
                {t.title}
              </h3>

              {/* Content */}
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}